import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import "./Contact.scss";

const ContactUs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    weddingDate: "",
    location: "",
    package: "",
    fomoVideo: "",
    contactMethod: "",
    contactTime: "",
    additionalInfo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    try {
      await fetch("/", {
        method: "POST",
        body: formData,
      });

      navigate(`/${lang || "en"}/confirmation`);
    } catch (err) {
      console.error("Form submit error:", err);
    }
  };
  // const languageKey = lang || "en";

  return (
    <div
      className="contact-us"
      style={{ backgroundImage: 'url("/Images/contact1.jpg")' }}
    >
      <div className="form-container">
        <h1 className="form-container__title">{t("contact.title")}</h1>
        <p className="form-container__description">
          {t("contact.description")}
        </p>

        <form
          name="contact"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
        >
          {/* Netlify bot field */}
          <input type="hidden" name="form-name" value="contact" />
          <p style={{ display: "none" }}>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>

          <div className="form-group">
            <label>{t("contact.name")}</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t("contact.namePlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contact.email")}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={t("contact.emailPlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contact.phone")}</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={t("contact.phonePlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contact.weddingDate")}</label>
            <input
              type="date"
              name="weddingDate"
              value={formData.weddingDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contact.location")}</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder={t("contact.locationPlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contact.packageQuestion")}</label>
            <div>
              {["Diamond", "Gold", "Silver", "Pearl"].map((pkg) => (
                <label key={pkg}>
                  <input
                    type="radio"
                    name="package"
                    value={pkg}
                    onChange={handleChange}
                    required
                  />{" "}
                  {t(`contact.packages.${pkg.toLowerCase()}`)}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>{t("contact.fomoQuestion")}</label>
            <div>
              <label>
                <input
                  type="radio"
                  name="fomoVideo"
                  value="Yes"
                  onChange={handleChange}
                  required
                />{" "}
                {t("contact.yes")}
              </label>
              <label>
                <input
                  type="radio"
                  name="fomoVideo"
                  value="No"
                  onChange={handleChange}
                />{" "}
                {t("contact.no")}
              </label>
            </div>
          </div>

          <div className="form-group">
            <label>{t("contact.contactMethodQuestion")}</label>
            <div>
              {["Phonecall", "Zoom", "Email"].map((method) => (
                <label key={method}>
                  <input
                    type="radio"
                    name="contactMethod"
                    value={method}
                    onChange={handleChange}
                    required={method === "Phonecall"}
                  />{" "}
                  {t(`contact.contactMethods.${method.toLowerCase()}`)}
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>{t("contact.contactTimeQuestion")}</label>
            <input
              type="text"
              name="contactTime"
              value={formData.contactTime}
              onChange={handleChange}
              placeholder={t("contact.contactTimePlaceholder")}
              required
            />
          </div>

          <div className="form-group">
            <label>{t("contact.additionalInfo")}</label>
            <textarea
              name="additionalInfo"
              value={formData.additionalInfo}
              onChange={handleChange}
              placeholder={t("contact.additionalInfoPlaceholder")}
            ></textarea>
          </div>

          <button type="submit" className="submit-button">
            {t("contact.submitButton")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
